<template>
  <Layout @clear-filter="asyncGetVehicles" @vehicle-search="asyncGetVehicles">
    <div class="top-actions">
      <div class="row">
        <div class="col-4">
          <div class="flex justify-start">
            <q-btn color="orange" v-if="route === routes.vehicleList" @click="setRoute(routes.selectionList)">
              <template>
                <div>
                  <q-icon name="fas fa-eye" class="q-mr-sm"/>
                  <span class="q-gutter-md">
                    <span>Select for BlackBook</span>
                    <span v-if="selectedItems.length > 0">({{ selectedItems.length }})</span>
                  </span>
                </div>
              </template>
            </q-btn>
            <div v-else-if="route === routes.selectionList">
              <q-btn color="green" class="q-mr-sm"
                     :disable="selectedItems < 1 || isSaveVehicles"
                     @click="isSaveVehicles = true">
                <template>
                  <div>
                    <q-icon name="fas fa-check" class="q-mr-sm"/>
                    <span class="q-gutter-md">
                      <span>Run Blackbook</span>
                      <span v-if="selectedItems.length > 0">({{ selectedItems.length }})</span>
                    </span>
                  </div>
                </template>
              </q-btn>
              <q-btn color="red" :disable="selectedItems < 1" @click="clearSelectionConfirm = true">
                <template>
                  <div>
                    <q-icon name="fas fa-broom" class="q-mr-sm"/>
                    <span class="q-gutter-md">
                      <span>Clear List</span>
                    </span>
                  </div>
                </template>
              </q-btn>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="flex justify-end">
            <q-btn color="purple"
                   class="q-mr-md"
                   @click="setRoute(routes.vehicleList)" v-if="route !== routes.vehicleList">
              <template>
                <div>
                  <q-icon name="fas fa-arrow-left" class="q-mr-sm"/>
                  <span class="q-gutter-md">
                    <span>Back to vehicle list</span>
                  </span>
                </div>
              </template>
            </q-btn>
            <q-btn color="teal" class="q-mr-md" @click="$router.push({name: 'blackbook_list'})">
              <template>
                <div>
                  <q-icon name="fas fa-list" class="q-mr-sm"/>
                  <span class="q-gutter-md">
                    <span>History</span>
                  </span>
                </div>
              </template>
            </q-btn>
            <q-btn-dropdown color="green" label="Bulk Selection" icon="fas fa-file-excel">
              <q-list>
                <q-item clickable v-close-popup @click="isImportModalOpen = true">
                  <q-item-section>
                    <q-item-label>
                      <q-icon name="fas fa-file-import" class="q-mr-sm"/>
                      <span>Import from excel file</span>
                    </q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup @click="downloadTemplate">
                  <q-item-section>
                    <q-item-label>
                      <q-icon name="fas fa-download" class="q-mr-sm"/>
                      <span>Download excel template</span>
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown>
          </div>
        </div>
      </div>
    </div>

    <q-dialog v-model="clearSelectionConfirm" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <span class="q-ml-sm">All changes will be lost! Are you sure you want to clean?</span>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn label="Yes" color="red" v-close-popup @click="clearSelection"/>
          <q-btn label="No" color="primary" v-close-popup/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="deleteSelectedItemConfirm" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <span class="q-ml-sm">Are you sure you want to delete?</span>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn label="Yes" color="red" v-close-popup @click="handleDeleteSelectedItem(deleteSelectedItemId)"/>
          <q-btn label="No" color="primary" @click="deleteSelectedItemId = null" v-close-popup/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <blackbook-import-excel-modal></blackbook-import-excel-modal>

    <div class="advanced-vehicles scroll scroll-content" v-if="route === routes.vehicleList">
      <q-card style="padding: 15px" v-if="items.length === 0 && !loading">
        <empty-value description="If you want to add vehicle please go to vehicle page." name="vehicle"></empty-value>
      </q-card>

      <div v-else style="position: relative;">
        <div class="row" v-if="!loading">
          <q-card :class="$q.screen.gt.sm ? 'column' : 'row'" class="inner-side-sticky">
            <div class="col-12" v-for="(item, index) in sideEffects" :key="index"
                 :style="item.visible && item.value !== null ? 'display:flex' : 'display:none'">
              <div
                :class="`side-effect${item.button ? ' clickable' : ''}`"
                @click="exportExcel(item)"
                :style="
                  (item.color > 0 && index === 4
                    ? 'background:#4caf50'
                    : index === 4
                    ? 'background:#f44336'
                    : 'background:#000')
                ">
                <div class="card-value">
                  {{ item.value }}
                </div>
                <div class="card-title">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </q-card>

          <div id="table-scroll" :class="'table-scroll' + (sortLoading ? ' sorting' : '')" ref="tablev1">
            <q-btn
              v-if="items.length > 0"
              class="glossy custom-item-icon left-0"
              style="margin-left: -10px"
              @mousedown="shiftLeft()"
              @mouseup="shiftLeftEnd()"
              round
              color="primary"
              icon="fas fa-arrow-left"
            />
            <q-btn
              v-if="items.length > 0"
              class="glossy custom-item-icon right-0"
              @mouseup="shiftRightEnd()"
              @mousedown="shiftRight()"
              round
              color="primary"
              icon="fas fa-arrow-right"
            />
            <table id="main-table" class="main-table" v-if="items.length > 0">
              <draggable v-bind="dragOptions" @start="drag = true" @end="drag = false" v-model="columns" tag="thead">
                <transition-group class="head-tr" tag="tr" type="transition" :name="drag ? 'flip-list' : null">
                  <th
                    style="cursor: all-scroll"
                    v-for="col in columns"
                    @click="sortTable(col.val)"
                    :key="col.val"
                    scope="col"
                    :style="
                      visibleColumns.some(item => item.name === col.name) || col.val === 'index'
                        ? 'display:table-cell'
                        : 'display:none'
                    "
                  >
                    <div v-if="col.name !== 'SELECT' && col.name !== 'Graph'">
                      {{ col.name }}
                      <i
                        v-if="col.val === sortColumn"
                        :class="sortDirection === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"
                        style="font-size: 12px"
                      ></i>
                    </div>
                    <div v-else style="display: flex; align-items: center; justify-content: center;"></div>
                  </th>
                </transition-group>
              </draggable>
              <transition-group name="flip-list" tag="tbody">
                <tr class="hoverable-tr" v-for="(item, idx) in items" :key="item.id">
                  <td
                    :class="
                      visibleColumns.some(item => item.name === header.name) || header.name === 'Line #'
                        ? 'table-cell'
                        : 'table-none'
                    "
                    :style="
                      (conditionChooser.val === 'default' ? item.revenue : item[`${conditionChooser.val}_revenue`]) > 0
                        ? selectedItems.some(sel => sel === item.id)
                          ? 'background:rgba(76, 175, 80, .5)'
                          : 'background:rgba(76, 175, 80, .1)'
                        : selectedItems.some(sel => sel === item.id)
                        ? 'background:rgba(244, 67, 54,.5)'
                        : 'background:rgba(244, 67, 54,.1)'
                    "
                    v-for="header in columns"
                    :key="header.val"
                  >
                    <div
                      v-if="
                        header.val !== 'index' &&
                        header.val !== 'selection' &&
                        header.val !== 'graph' &&
                        header.val !== 'tags' &&
                        header.val !== 'condition_grade' &&
                        header.val !== 'condition' &&
                        header.val !== 'auction' &&
                        header.val !== 'blackbook_auction' &&
                        header.val !== 'auction_weekly_change' &&
                        header.val !== 'estimated_cap_cost' &&
                        header.val !== 'purchase_amount' &&
                        header.val !== 'in_service_date' &&
                        header.val !== 'status'
                      "
                    >
                      {{ valueSpawner(typeof item[header.val], item[header.val], header, item) }}
                      <!--  -->
                    </div>
                    <div v-else-if="header.val === 'graph'">
                      <div class="graph-btn" @click.prevent="openSetMarketValueHistoryDialog(item)">
                        <i class="fas fa-chart-line fa-2x"></i>
                      </div>
                    </div>
                    <div v-else-if="header.val === 'tags'" class="tag-table-container">
                      <div v-if="item[header.val].length === 0">-</div>
                      <div
                        v-else
                        :style="randomColorGenerator(tag.color, index)"
                        class="tag-item"
                        v-for="(tag, index) in item[header.val]"
                        :key="index"
                      >
                        {{ index < 2 ? tag.name[0] : `+${item[header.val].length - 2}` }}
                        <q-tooltip>{{
                            index < 2 ? tag.name : `+${item[header.val].length - 2} more manual`
                          }}
                        </q-tooltip>
                      </div>
                    </div>
                    <div v-else-if="header.val === 'index'">
                      {{ idx + 1 }}
                    </div>
                    <div v-else-if="header.val === 'condition_grade'">{{ conditionGradeSpawner(item) }}</div>
                    <div v-else-if="header.val === 'condition'">
                      <span>
                        {{ conditionSpawner(item, item[header.val]) }}
                      </span>
                      <q-menu v-if="conditionChooser.val === 'default'" style="width: 300px">
                        <q-list style="min-width: 100px">
                          <q-item
                            v-for="cond in conditions"
                            :key="cond.val"
                            @click="updateVehicleCond(item, cond)"
                            clickable
                            v-close-popup
                          >
                            <q-item-section>
                              <span :style="item[header.val] === cond.val ? 'color:#1976D2' : ''">{{ cond.name }}</span>
                            </q-item-section>
                          </q-item>
                        </q-list>
                      </q-menu>
                    </div>
                    <div v-else-if="header.val === 'auction'">
                      <div @click="openSetDefaultMarketValueDialog(item)">
                        <div :class="isManuallyPriced(item) || isLatestPositivePrice(item) ? 'underlined' : ''">
                          {{ auctionSpawner(item) }}
                        </div>
                      </div>
                    </div>
                    <div v-else-if="header.val === 'blackbook_auction'">
                      <div v-if="item['last_blackbook_value'] !== null" style="min-width: 100px;">
                        <q-tooltip>
                          <template>
                            <div style="min-width: 130px;">
                              <div class="row">
                                <div class="col-4 text-right q-pr-md">XClean:</div>
                                <div class="col-8">{{ getBlackbookValue(item, 'adjusted_whole_xclean') | formatPrice }}</div>
                              </div>
                              <div class="row">
                                <div class="col-4 text-right q-pr-md">Clean:</div>
                                <div class="col-8">{{ getBlackbookValue(item, 'adjusted_whole_clean') | formatPrice }}</div>
                              </div>
                              <div class="row">
                                <div class="col-4 text-right q-pr-md">Average:</div>
                                <div class="col-8">{{ getBlackbookValue(item, 'adjusted_whole_avg') | formatPrice }}</div>
                              </div>
                              <div class="row">
                                <div class="col-4 text-right q-pr-md">Rough:</div>
                                <div class="col-8">{{ getBlackbookValue(item, 'adjusted_whole_rough') | formatPrice }}</div>
                              </div>
                            </div>
                          </template>
                        </q-tooltip>
                        <div :class="!item['last_blackbook_value']['is_self'] ? 'underlined' : ''">
                          {{ getBlackbookValue(item, 'adjusted_whole_avg') | formatPrice }}
                        </div>
                        <small>{{ item['last_blackbook_value']['created_at'] | dateTimeFormat }}</small>
                      </div>
                      <div v-else>-</div>
                    </div>
                    <div v-else-if="header.val === 'auction_weekly_change'">
                      <div class="flex flex-center"
                           :style="weeklyChangeColor(item[header.val])">
                        <q-icon :name="`fas fa-${weeklyChangeIcon(item[header.val])}`" size="10px"
                                style="margin-right: 3px;"></q-icon>
                        <span>{{ item[header.val] }}%</span>
                      </div>
                    </div>
                    <div style="width:100px" v-else-if="header.val === 'estimated_cap_cost'">
                      {{ item[header.val] | formatPrice }}
                    </div>
                    <div style="width:100px" v-else-if="header.val === 'purchase_amount'">
                      {{ item['purchase_amount'] | formatPrice }}
                    </div>
                    <div style="width:100px" v-else-if="header.val === 'in_service_date'">
                      {{ formatDate(item[header.val]) }}
                    </div>
                    <div v-else-if="header.val === 'status'">
                      {{ getLabelByValue(item.status) }}
                    </div>
                    <q-btn round size="sm" v-else
                           :color="selectedItems.some(i => i.id === item.id) ? 'green' : 'grey'"
                           @click.native="toggleSelectedItem(item)">
                      <template v-slot:default>
                        <q-icon name="fas fa-check" v-if="selectedItems.some(i => i.id === item.id)"/>
                      </template>
                    </q-btn>
                  </td>
                </tr>
              </transition-group>
            </table>
          </div>

          <div class="loading-infinite" v-if="infiniteLoading">
            <div>
              <q-spinner-facebook color="primary" size="40px"/>
              <div class="text-grey-7">Loading</div>
            </div>
          </div>
        </div>
        <q-card style="height: 350px; background: #fff" class="loading-infinite" v-if="loading">
          <div>
            <q-spinner-facebook color="primary" size="40px"/>
            <div class="text-grey-7">Loading</div>
          </div>
        </q-card>
      </div>
      <advanced-filter-modal @getParams="setParams"></advanced-filter-modal>
      <vehicle-market-value-history-dialog></vehicle-market-value-history-dialog>
      <vehicle-default-market-value-dialog></vehicle-default-market-value-dialog>
      <export-excel :selection="selectedItems" @clearVehicles="setClearVehicles"></export-excel>
      <vehicle-sell-dialog></vehicle-sell-dialog>
      <vehicle-sell-history-dialog></vehicle-sell-history-dialog>
    </div>

    <div class="advanced-vehicles scroll scroll-content" v-if="route === routes.selectionList">
      <selection-list :on-delete-item="onDeleteItem"></selection-list>
    </div>
  </Layout>
</template>

<script>
import axios from '@/axios'
import Layout from '@/components/Layout'
import AdvancedFilterModal from '@/components/AdvancedFilterModal'
import EmptyValue from '@/components/EmptyValue'
import draggable from 'vuedraggable'
import VehicleDefaultMarketValueDialog from "@/components/VehicleDefaultMarketValueDialog";
import VehicleMarketValueHistoryDialog from "@/components/VehicleMarketValueHistoryDialog.vue";
import {defaultStatusValues, getLabelByValue} from "@/enums";
import {routes} from "@/components/blackbook/routes";
import SelectionList from "@/components/blackbook/SelectionList.vue";
import BlackbookImportExcelModal from "@/components/BlackbookImportExcelModal.vue";
import VehicleSellHistoryDialog from "@/components/VehicleSellHistoryDialog.vue";
import VehicleSellDialog from "@/components/VehicleSellDialog.vue";
import ExportExcel from "@/components/ExportExcel.vue";

export default {
  components: {
    ExportExcel,
    VehicleSellDialog, VehicleSellHistoryDialog,
    BlackbookImportExcelModal,
    SelectionList,
    VehicleMarketValueHistoryDialog,
    EmptyValue,
    draggable,
    AdvancedFilterModal,
    VehicleDefaultMarketValueDialog,
    Layout
  },
  metaInfo() {
    return {
      title: 'List of Current Fleet information including MMR & Pay-off Information | FMS',
      meta: [
        {
          name: 'description',
          content: ''
        },
        {
          property: 'og:title',
          content: 'Blackbook | FMS'
        },
        {property: 'og:site_name', content: 'FMS'},
        {property: 'og:type', content: 'website'},
        {name: 'robots', content: 'index,follow'}
      ]
    }
  },
  data() {
    return {
      loading: true,
      rightInterval: null,
      leftInterval: null,
      condition: {},
      conditions: [
        {
          name: 'Above',
          val: 'excellent'
        },
        {
          name: 'Average',
          val: 'good'
        },
        {
          name: 'Below',
          val: 'fair'
        }
      ],
      drag: false,
      sort: {
        name: '',
        count: 0
      },
      all: false,
      columns: [
        {
          name: 'Line #',
          val: 'index'
        },
        {
          name: 'SELECT',
          val: 'selection'
        },
        {
          name: 'Graph',
          val: 'graph'
        },
        {
          name: 'Company',
          val: 'company'
        },
        {
          name: 'Location',
          val: 'location'
        },
        {
          name: 'Unit',
          val: 'unit'
        },
        {
          name: 'Vehicle Class',
          val: 'class_name'
        },
        {
          name: 'VIN',
          val: 'vin'
        },
        {
          name: 'Model Year',
          val: 'model_year'
        },
        {
          name: 'Make',
          val: 'brand'
        },
        {
          name: 'Model',
          val: 'model'
        },
        {
          name: 'Model Detail',
          val: 'model_detail'
        },
        {
          name: 'In Service Date',
          val: 'in_service_date'
        },
        {
          name: 'Months in Service',
          val: 'months_in_service'
        },
        {
          name: 'Mileage',
          val: 'mileage'
        },
        {
          name: 'AVG CR',
          val: 'condition_grade'
        },
        {
          name: 'Condition',
          val: 'condition'
        },
        {
          name: 'Manheim Auction Value',
          val: 'auction'
        },
        {
          name: "Blackbook Auction Value",
          val: "blackbook_auction",
        },
        {
          name: 'Manheim Auction Weekly Change',
          val: 'auction_weekly_change'
        },
        {
          name: 'Estimated Payoff',
          val: 'payoff'
        },
        {
          name: 'Estimated Revenue/Loss',
          val: 'revenue'
        },
        {
          name: "Estimated Cap Cost",
          val: "estimated_cap_cost",
        },
        {
          name: "Initial Purchase Price",
          val: "purchase_amount",
        },
        {
          name: 'Monthly Payment',
          val: 'monthly_payment'
        },
        {
          name: 'Remaning Months',
          val: 'remaining'
        },
        {
          name: 'Color',
          val: 'color'
        },
        {
          name: 'Finance',
          val: 'source',
          sub: 'Finance'
        },
        {
          name: 'Custom Tag',
          val: 'tags'
        },
        {
          name: 'Status',
          val: 'status'
        }
      ],
      columnsMobile: [
        {
          name: 'Unit',
          val: 'unit'
        },
        {
          name: 'Location',
          val: 'location'
        },
        {
          name: 'Company',
          val: 'company'
        },
        {
          name: 'Estimated Revenue/Loss',
          val: 'revenue'
        },
        {
          name: 'Status',
          val: 'status'
        }
      ],
      reportLoading: false,
      items: [],
      firstRequest: true,
      per: 100,
      page: 1,
      lastPage: 1,
      infiniteLoading: false,
      sortLoading: false,
      sortColumn: 'unit',
      sortDirection: 'asc',
      clearSelectionConfirm: false,
      deleteSelectedItemConfirm: false,
      deleteSelectedItemId: null,
      companies: [],
      results: [
        {
          label: 'Success',
          value: 'success'
        },
        {
          label: 'Failed',
          value: 'failed'
        }
      ],
      summaryInitialData: {
        count: 0,
        payoff: 0,
        revenue: 0,
        auction: 0,
        avg_mileage: null
      },
    }
  },
  created() {
    this.$store.commit('profit/SET_VEHICLES', [])
    setTimeout(() => {
      document.querySelector('.scroll-content').addEventListener('scroll', this.onScroll)
    }, 1000)
  },
  destroyed() {
    document.querySelector('.scroll-content').removeEventListener('scroll', this.onScroll)
  },
  async mounted() {
    await this.getCompanies()
    this.route = this.routes.vehicleList
    this.$root.$on('takeReport', () => {
      if (this.selectedItems.length === 0) return
      this.generate()
    })
    this.$root.$on('tagUpdateCheckVehicles', ({id, name, color}) => {
      for (const vehicle of this.items) {
        const {tags} = vehicle
        const isExistTagOnVehicle = tags.filter(tag => tag.id === id)[0]
        const props = {
          name,
          color,
          vehicle_id: vehicle.id
        }
        if (isExistTagOnVehicle && isExistTagOnVehicle.id)
          this.$store.commit('vehicle/UPDATE_VEHICLE_EXISTS_TAG', {
            ...props,
            tag_id: isExistTagOnVehicle.id
          })
      }
    })
    this.$store.state.tag.tags.length === 0 ? await this.getTags() : ''
    if (this.$store.state.profit.vehicles.length === 0) {
      this.loading = true
      await this.getFilters()
      await this.getVehicles()
      await this.getSummary()
      this.loading = false
    }
  },
  computed: {
    routes() {
      return routes
    },
    financial: {
      get() {
        return this.$store.state.profit.financial
      },
      set(val) {
        this.$store.commit('profit/SET_FINANCIAL', val)
      }
    },
    conditionSpawner() {
      return (row, condition) => {
        if (this.conditionChooser.val !== 'default') return this.conditionChooser.name
        else return this.conditions.filter(item => item.val === condition)[0].name
      }
    },
    conditionChooserFilter: {
      get() {
        return this.$store.state.profit.conditionChooserFilter
      },
      set(val) {
        this.$store.commit('profit/SET_FILTER_CONDITION', val)
      }
    },
    conditionChooser: {
      get() {
        return this.$store.state.profit.conditionChooser
      },
      set(val) {
        this.$store.commit('profit/SET_CONDITION_SETTER', val)
      }
    },
    randomColorGenerator() {
      return (color, index) => {
        if (index === 0 || index === 1) return `background:${color}`
        else if (index === 2) return 'background:#F2C037'
        else return 'display:none'
      }
    },
    tags: {
      get() {
        return this.$store.state.tag.tags
      },
      set(val) {
        this.$store.commit('tag/SET_TAGS', val)
      }
    },
    valueSpawner() {
      return (type, val, column, row) => {
        if (column.name === 'Line #') return val
        if (type === 'object') return val && val.name ? val.name : '-'
        else {
          if (
            column.name !== 'Auction Value' &&
            column.name !== 'Estimated Payoff' &&
            column.name !== 'Monthly Payment' &&
            column.name !== 'Estimated Revenue/Loss' &&
            column.name !== 'Mileage'
          ) {
            return val
          } else if (column.name === 'Mileage') {
            return val.toLocaleString('en-US')
          } else if (column.name === 'Estimated Revenue/Loss') {
            return this.conditionChooser.val !== 'default'
              ? row[`${this.conditionChooser.val}_revenue`].toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              })
              : val.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
              })
          } else {
            return val.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD'
            })
          }
        }
      }
    },
    isManuallyPriced() {
      return (row) => {
        if (row.auction === null) return false;
        return row.default_market_value != null;
      }
    },
    isLatestPositivePrice() {
      return (row) => {
        if ((row.auction === null || parseInt(row.auction.toString()) === 0) &&
          (row.latest_positive_market_value !== null && row.latest_positive_market_value[row.condition] > 0)) {
          return true;
        }
      }
    },
    conditionGradeSpawner() {
      return (row) => {
        return row.last_mileage_record?.market_values[0] ?
          row.last_mileage_record?.market_values[0].condition_grade.toFixed(1) : '-'
      }
    },
    auctionSpawner() {
      return (row) => {
        let condition = row.condition ?? 'good';
        if (this.conditionChooser.val !== 'default') {
          condition = this.conditionChooser.val;
        }

        let auction = row.last_mileage_record?.market_values.length > 0 ?
          row.last_mileage_record?.market_values[0][condition] : null;
        if (!auction && row.latest_positive_market_value !== null) {
          auction = row.latest_positive_market_value[condition];
        }

        if (!auction) {
          auction = row.default_market_value;
        }
        if (auction) {
          return auction.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          })
        } else {
          return '-'
        }
      }
    },
    visibleColumns() {
      return this.$store.state.profit.visibleColumns
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    exportEx: {
      get() {
        return this.$store.state.profit.export
      },
      set(val) {
        this.$store.commit('profit/SET_EXPORT', val)
      }
    },
    selectAll: {
      get() {
        return this.items ? this.selectedItems.length === this.items.length : false
      },
      set(value) {
        if (value) {
          this.selectedItems = this.items
        } else {
          this.selectedItems = []
        }
      }
    },
    posRev: {
      get() {
        return this.$store.state.profit.posRev
      },
      set(val) {
        this.$store.commit('profit/SET_POS_REV', val)
      }
    },
    negRev: {
      get() {
        return this.$store.state.profit.negRev
      },
      set(val) {
        this.$store.commit('profit/SET_NEG_REV', val)
      }
    },
    total: {
      get() {
        return this.$store.state.profit.total
      },
      set(val) {
        this.$store.commit('profit/SET_TOTAL', val)
      }
    },
    mmr: {
      get() {
        return this.$store.state.profit.mmr
      },
      set(val) {
        this.$store.commit('profit/SET_MMR', val)
      }
    },
    mileage: {
      get() {
        return this.$store.state.profit.mileage
      },
      set(val) {
        this.$store.commit('profit/SET_MILEAGE', val)
      }
    },
    payOff: {
      get() {
        return this.$store.state.profit.payOff
      },
      set(val) {
        this.$store.commit('profit/SET_PAY_OFF', val)
      }
    },
    revenue: {
      get() {
        return this.$store.state.profit.revenue
      },
      set(val) {
        this.$store.commit('profit/SET_REVENUE', val)
      }
    },
    monthlyPayment: {
      get() {
        return this.$store.state.profit.monthlyPayment
      },
      set(val) {
        this.$store.commit('profit/SET_MONTHLY_PAYMENT', val)
      }
    },
    avgRevenue: {
      get() {
        return this.$store.state.profit.avgRevenue
      },
      set(val) {
        this.$store.commit('profit/SET_AVG_REVENUE', val)
      }
    },
    avgMileage: {
      get() {
        return this.$store.state.profit.avgMileage
      },
      set(val) {
        this.$store.commit('profit/SET_AVG_MILEAGE', val)
      }
    },
    vehicles: {
      get() {
        return this.$store.state.profit.vehicles
      },
      set(val) {
        this.$store.commit('profit/SET_VEHICLES', val)
      }
    },
    manuallyPriced() {
      return this.$store.state.profit.manuallyPriced
    },
    advancedFilters: {
      get() {
        return this.$store.state.profit.advancedFilters
      },
      set(val) {
        this.$store.commit('profit/SET_ADVANCED_FILTER', val)
      }
    },
    locations: {
      get() {
        return this.$store.state.profit.locations
      },
      set(val) {
        this.$store.commit('profit/SET_LOCATIONS', val)
      }
    },
    companyFilter: {
      get() {
        return this.$store.state.profit.companyFilter
      },
      set(val) {
        this.$store.commit('profit/SET_COMPANY_FILTER', val)
      }
    },
    multiFilter: {
      get() {
        return this.$store.state.profit.multiFilter
      },
      set(val) {
        this.$store.commit('profit/SET_MULTI_FILTER', val)
      }
    },
    statusFilter: {
      get() {
        return this.$store.state.profit.statusFilter
      },
      set(val) {
        this.$store.commit('profit/SET_STATUS_FILTER', val)
      }
    },
    search: {
      get() {
        return this.$store.state.profit.search
      },
      set(val) {
        this.$store.commit('profit/SET_SEARCH', val)
      }
    },
    source: {
      get() {
        return this.$store.state.profit.source
      },
      set(val) {
        this.$store.commit('profit/SET_SOURCES', val)
      }
    },
    group: {
      get() {
        return this.$store.state.profit.group
      },
      set(val) {
        this.$store.commit('profit/SET_GROUPS', val)
      }
    },
    class: {
      get() {
        return this.$store.state.profit.class
      },
      set(val) {
        this.$store.commit('profit/SET_CLASSES', val)
      }
    },
    brandId: {
      get() {
        return this.$store.state.profit.brandId
      },
      set(val) {
        this.$store.commit('profit/SET_BRANDS_ID', val)
      }
    },
    modelYear: {
      get() {
        return this.$store.state.profit.modelYear
      },
      set(val) {
        this.$store.commit('profit/SET_MODEL_YEARS', val)
      }
    },
    modelId: {
      get() {
        return this.$store.state.profit.modelId
      },
      set(val) {
        this.$store.commit('profit/SET_MODELS_ID', val)
      }
    },
    sign: {
      get() {
        return this.$store.state.profit.sign
      },
      set(val) {
        this.$store.commit('profit/SET_SIGN', val)
      }
    },
    min: {
      get() {
        return this.$store.state.profit.min
      },
      set(val) {
        this.$store.commit('profit/SET_MIN', val)
      }
    },
    max: {
      get() {
        return this.$store.state.profit.max
      },
      set(val) {
        this.$store.commit('profit/SET_MAX', val)
      }
    },
    queryParams() {
      return type => {
        const params = {}
        if (this.companyFilter.id) params.company_id = this.companyFilter.id
        if (this.multiFilter.length > 0) params.location_id = this.multiFilter.map(item => item.id)
        if (this.selectedTags.length > 0) params.tag_id = this.selectedTags.map(i => i.id)
        if (this.search !== '') params.q = this.search
        if (this.conditionChooserFilter.length > 0) params.condition = this.conditionChooserFilter.map(item => item.val)
        params.provider = this.provider.key
        if (type.type === 'vehicle') {
          params.financial = this.financial
          if (this.source.length > 0) params.source = this.source.map(item => item)
          if (this.group.length > 0) params.group = this.group.map(item => item)
          if (this.class.length > 0) params.class = this.class.map(item => item)
          if (this.brandId.length > 0) {
            params.brand_id = this.brandId.map(item => item.id)
            params.model_id = [].concat
              .apply(
                [],
                this.brandId.map(item => item.models)
              )
              .map(item => item.id)
          }
          if (this.modelYear.length > 0) params.model_year = this.modelYear.map(item => item)
          if (this.sign && this.sign.value) params.sign = this.sign.value
          if (this.min) params.min = parseInt(this.min)
          if (this.max) params.max = parseInt(this.max)
        }
        if (this.statusFilter.length > 0) params.statuses = this.statusFilter.map(item => item.value)
        return {params}
      }
    },
    provider: {
      get() {
        return this.$store.state.profit.provider
      },
      set(val) {
        this.$store.commit('profit/SET_PROVIDER', val)
      }
    },
    selectedTags: {
      get() {
        return this.$store.state.profit.selectedTags
      },
      set(val) {
        this.$store.commit('profit/SET_TAG_CONDITION', val)
      }
    },
    setDefaultMarketValueDialog: {
      get() {
        return this.$store.state.vehicle.setDefaultMarketValueDialog
      },
      set(val) {
        this.$store.commit('vehicle/SET_DEFAULT_MARKET_VALUE_DIALOG', val)
      }
    },
    setMarketValueHistoryDialog: {
      get() {
        return this.$store.state.vehicle.setMarketValueHistoryDialog
      },
      set(val) {
        this.$store.commit('vehicle/SET_MARKET_VALUE_HISTORY_DIALOG', val)
      }
    },
    getMarketValueHistoryDialog() {
      return this.$store.getters.vehicle.getMarketValueHistoryDialog
    },
    defaultMarketValueUpdated: {
      get() {
        return this.$store.state.profit.defaultMarketValueUpdated
      },
      set(val) {
        this.$store.commit('profit/SET_DEFAULT_MARKET_VALUE_UPDATED', val)
      }
    },
    selectedItems: {
      get() {
        return this.$store.state.blackbook.selectedItems
      },
      set(val) {
        this.$store.commit('blackbook/SET_SELECTED_ITEMS', val)
      }
    },
    isImportModalOpen: {
      get() {
        return this.$store.state.blackbook.isImportModalOpen
      },
      set(val) {
        this.$store.commit('blackbook/SET_IS_IMPORT_MODAL', val)
      }
    },
    selectedVehicles: {
      get() {
        return this.$store.state.blackbook.selectedVehicles
      },
      set(val) {
        this.$store.commit('blackbook/SET_SELECTED_VEHICLES', val)
      }
    },
    isSaveVehicles: {
      get() {
        return this.$store.state.blackbook.isSaveVehicles
      },
      set(val) {
        this.$store.commit('blackbook/SET_IS_SAVE_VEHICLES', val)
      }
    },
    historyFilter: {
      get() {
        return this.$store.state.blackbook.historyFilter
      },
      set(val) {
        this.$store.commit('blackbook/SET_HISTORY_FILTER', val)
      }
    },
    selectedHistoryItems: {
      get() {
        return this.$store.state.blackbook.selectedHistoryItems;
      },
      set(val) {
        this.$store.commit("blackbook/SET_SELECTED_HISTORY_ITEMS", val);
      },
    },
    route: {
      get() {
        return this.$store.state.blackbook.route
      },
      set(val) {
        this.$store.commit('blackbook/SET_ROUTE', val)
      }
    },
    setSellDialog: {
      get() {
        return this.$store.state.vehicle.setSellDialog
      },
      set(val) {
        this.$store.commit('vehicle/SET_SELL_DIALOG', val)
      }
    },
    setSellHistoryDialog: {
      get() {
        return this.$store.state.vehicle.setSellHistoryDialog
      },
      set(val) {
        this.$store.commit('vehicle/SET_SELL_HISTORY_DIALOG', val)
      }
    },
    sideEffects() {
      return [
        {
          name: 'EXPORT',
          visible: true,
          button: true
        },
        {
          name: 'Unit Selected',
          value: this.total,
          visible: true,
          button: false
        },
        {
          name: 'Auction Value',
          value: this.mmr.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          }),
          color: this.payOff,
          visible: true,
          button: false
        },
        {
          name: 'Estimated Payoff',
          value: this.payOff.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          }),
          visible: !!this.financial,
          button: false
        },
        {
          name: 'Estimated Revenue/Loss',
          value: this.revenue.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          }),
          color: this.revenue,
          visible: !!this.financial,
          button: false
        },
        {
          name: 'Avg Per Unit Mileage',
          value: this.avgMileage ? this.avgMileage
            .toFixed(0)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',') : null,
          visible: true,
          button: false
        }
      ]
    },
  },
  methods: {
    getLabelByValue,
    async getCompanies() {
      this.isLoading = true
      const {data} = await axios.get('/companies')
      this.companies = data.data.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      })
      this.isLoading = false
    },
    formatDate(date) {
      if (date === null) return ''
      const d = date.split(' ')[0].split('-')
      return `${d[1]}/${d[2]}/${d[0]}`
    },
    shiftRight() {
      this.rightInterval = setInterval(() => {
        this.$refs.tablev1.scrollLeft += 50
      }, 50)
    },
    shiftRightEnd() {
      clearInterval(this.rightInterval)
    },
    shiftLeft() {
      this.leftInterval = setInterval(() => {
        this.$refs.tablev1.scrollLeft -= 50
      }, 50)
    },
    shiftLeftEnd() {
      clearInterval(this.leftInterval)
    },
    async generate() {
      try {
        this.reportLoading = true
        const {
          data: {data, message}
        } = await axios.put('reports/history-reports', {
          vehicles: this.selectedItems.map(vehicle => vehicle.id)
        })
        this.$store.commit('history/ADD_REPORT', data)
        this.$q.notify({
          message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.setClearVehicles()
      } catch (error) {
        this.$q.notify({
          message: 'Something wrong.',
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.reportLoading = false
      }
    },
    conditionPutter(condition) {
      this.condition = this.conditions.filter(item => item.val === condition)[0]
    },
    async fetchItem(id) {
      const params = {
        vehicle_id: [id],
        provider: this.provider.key,
        statuses: this.statusFilter.map(item => item.value)
      }
      const {data} = await axios.post('vehicle-analysis/internal-list-for-sale', params)
      const index = this.items.findIndex(item => item.id === id)
      let item = null
      if (index !== -1) {
        this.items[index] = data.data.items[0]
        item = this.items[index]
        this.items.splice(index, 1, item)
      }
    },
    async updateVehicleCond(vehicle, cond) {
      const {id} = vehicle
      const body = {
        condition: cond.val
      }
      try {
        await axios.patch(`vehicle-condition/${id}`, body)
        await this.fetchItem(id)
        this.selectedItems = []
      } catch (error) {
        console.log(error)
      }
    },
    async getTags() {
      try {
        const {data} = await axios.get('vehicle-tags')
        this.tags = data.data
      } catch (error) {
      }
    },
    selectionVehicle(vehicle) {
      const {id} = vehicle
      const index = this.selectedItems.findIndex(item => item.id === id)
      index === -1 ? (this.selectedItems = [...this.selectedItems, vehicle]) : this.selectedItems.splice(index, 1)
    },
    async sortTable(row) {
      if (!this.sortLoading && row !== 'index' && row !== 'selection' && row !== 'tags'
        && row !== 'blackbook_auction') {
        if (this.sortColumn === row) {
          this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
        } else {
          this.sortDirection = 'asc'
        }
        this.sortColumn = row
        this.page = 1
        this.sortLoading = true
        await this.getVehicles()
        this.sortLoading = false
      }
    },
    setClearVehicles() {
      this.selectedItems = []
    },
    setParams(e) {
      this.asyncGetVehicles()
    },
    async asyncGetVehicles() {
      this.loading = true
      this.route = routes.vehicleList
      await this.getFilters()
      await this.getSummary()
      await this.getVehicles()
      this.loading = false
    },
    async getVehicles() {
      if (this.page > this.lastPage && !this.loading) {
        return false
      }

      const {params} = this.queryParams({type: 'vehicle'})
      params.per = this.per
      params.page = this.page
      params.sort = this.sortColumn
      params.order = this.sortDirection
      if (this.manuallyPriced !== null) {
        params.manually_priced = this.manuallyPriced
      }

      if (params.page !== 1) {
        this.infiniteLoading = true
      }

      if (this.firstRequest) {
        params.statuses = defaultStatusValues
        this.firstRequest = false
      }
      const {data} = await axios.post('vehicle-analysis/internal-list-for-sale', {}, {
        params
      })
      this.lastPage = data.data.pagination.last
      let deep = () => {
        if (this.page === 1) {
          return data.data.items.map(item => {
            item.retail = false
            item.wholesale = true
            return item
          })
        } else {
          let carbon = [...this.items]
          let nextPage = data.data.items.map(item => item)
          return carbon.concat(nextPage)
        }
      }
      this.items = deep()
      this.infiniteLoading = false
    },
    async getFilters() {
      const {params} = await this.queryParams({type: 'filter'})
      const {data} = await axios.post('vehicle-analysis/filter-properties', params)
      const val = data.data
      const deep = {...this.advancedFilters}
      for (const key in this.advancedFilters) {
        if (val.hasOwnProperty(key)) {
          if (key === 'providers') {
            deep.providers = val[key].items[1]
          } else deep[key] = val[key]
        }
      }
      this.advancedFilters = deep
    },
    async getLocations(companyId) {
      if (companyId) {
        try {
          const params = {company_id: companyId}
          const {data} = await axios.get(`locations`, {params})
          this.locations = data.data
        } catch (error) {
        } finally {
        }
      }
    },
    openSetDefaultMarketValueDialog(item) {
      this.setDefaultMarketValueDialog = {
        show: true,
        id: item['id'],
        vin: item['vin'],
        currentValue: item['default_market_value'],
      }
    },
    openSetMarketValueHistoryDialog(item) {
      this.setMarketValueHistoryDialog = {
        show: true,
        id: item['id'],
      }
    },
    async onScroll(e) {
      const obj = e.target
      if (obj.scrollTop >= obj.scrollHeight - obj.offsetHeight - 100) {
        if (this.items.length !== 0 && !this.loading && !this.infiniteLoading && this.page < this.lastPage) {
          this.page++
          await this.getVehicles()
        }
      }
    },
    weeklyChangeColor(val) {
      if (val > 0) return 'color:green'
      else if (val < 0) return 'color:red'
      else return 'color:gray'
    },
    weeklyChangeIcon(val) {
      if (val > 0) return 'arrow-up'
      else if (val < 0) return 'arrow-down'
      else return 'minus'
    },
    setRoute(route) {
      this.route = route
    },
    clearSelection() {
      this.selectedItems = []
    },
    onDeleteItem(id) {
      this.deleteSelectedItemId = id
      this.deleteSelectedItemConfirm = true
    },
    handleDeleteSelectedItem(id) {
      this.selectedItems = this.selectedItems.filter(item => item.id !== id)
      this.deleteSelectedItemId = null
    },
    async downloadTemplate() {
      try {
        const {data} = await axios.get('/blackbook/excel-template', {
          responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `blackbook-template.xlsx`)
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        console.log(err)
      }
    },
    toggleSelectedItem(item) {
      const index = this.selectedItems.findIndex(vehicle => vehicle.id === item.id)
      let condition_grade = null
      try {
        condition_grade = item.last_mileage_record?.market_values[0].condition_grade
      } catch (e) {
        condition_grade = null
      }

      if (index === -1) {
        this.selectedItems.push({
          id: item.id,
          vin: item.vin,
          unit: item.unit,
          group: item.group_name,
          class: item.class_name,
          make: item.brand?.name,
          model: item.model?.name,
          model_detail: item.model_detail?.name,
          model_year: item.model_year,
          color: item.color,
          condition: item.condition,
          mileage: item.last_mileage_record?.mileage,
          last_mileage_record: item.last_mileage_record,
          grade: condition_grade,
          state: item.company.state?.code,
          company: item.company,
          location: item.location,
          excellent_revenue: item.excellent_revenue,
          good_revenue: item.good_revenue,
          fair_revenue: item.fair_revenue,
          payoff: item.payoff,
          auction: item.auction,
          purchase_amount: item.finance?.purchase_amount,
        })
      } else {
        this.selectedItems.splice(index, 1)
      }
    },
    getBlackbookValue(item, key) {
      if (item === null) return '-'

      try {
        return item['last_blackbook_value']['data']['used_vehicles']['used_vehicle_list'][0][key]
      } catch (e) {
        return '-'
      }
    },
    async getSummary() {
      const {params} = this.queryParams({type: 'vehicle'})
      if (this.firstRequest) {
        params.statuses = defaultStatusValues
      }
      if (this.manuallyPriced !== null) {
        params.manually_priced = this.manuallyPriced
      }
      const url = 'vehicle-analysis/internal-list-summary-for-sale' +
        (this.previewCondition ? `?preview_condition=${this.previewCondition}` : '')
      const {data} = await axios.post(url, {}, {
        params
      });

      this.summaryInitialData = data.data.total
      await this.initSummaryData()
    },
    async initSummaryData() {
      this.total = this.summaryInitialData.count
      this.payOff = this.summaryInitialData.payoff
      this.revenue = this.summaryInitialData.revenue
      this.mmr = this.summaryInitialData.auction
      this.avgRevenue = this.summaryInitialData.revenue / this.summaryInitialData.count
      this.avgMileage = this.summaryInitialData.avg_mileage
    },
    sumRevenue(vehicles) {
      let sum = 0
      vehicles.forEach(item => {
        sum += this.conditionChooser.val !== 'default' ? item[`${this.conditionChooser.val}_revenue`] :
          item[`${item.condition}_revenue`]
      })
      return sum
    },
    sumAuction(vehicles) {
      let sum = 0
      vehicles.forEach(item => {
        sum += item.auction
      })
      return sum
    },
    allCalculator(n) {
      this.mileage = n.reduce((sum, {mileage}) => sum + mileage, 0)
      this.total = n.length
      this.revenue = this.sumRevenue(n)
      this.payOff = n.reduce((sum, {payoff}) => sum + payoff, 0)
      this.avgRevenue = this.revenue / n.length
      this.negRev = n.reduce((sum, acc) => {
        if (acc[this.conditionTyperForReducer] < 0) return sum + (acc[this.conditionTyperForReducer] || 0)
        else return sum + 0
      }, 0)
      this.posRev = n.reduce((sum, acc) => {
        if (acc[this.conditionTyperForReducer] > 0) return sum + (acc[this.conditionTyperForReducer] || 0)
        else return sum + 0
      }, 0)
      this.avgMileage = this.mileage / n.length
      this.mmr = this.sumAuction(n)
    },
    sellVehicles() {
      this.setSellDialog = {
        show: true,
        items: this.selectedItems,
        nested: false,
        completed: false,
      }
    },
    openSellHistoryDialog() {
      this.setSellHistoryDialog = {
        show: true,
      }
    },
    exportExcel(item) {
      if (item.name !== 'EXPORT') {
        return;
      }
      const {params} = this.queryParams({type: 'vehicle'})
      params.per = this.per
      params.page = this.page
      params.sort = this.sortColumn
      params.order = this.sortDirection
      if (this.manuallyPriced !== null) {
        params.manually_priced = this.manuallyPriced
      }

      if (params.page !== 1) {
        this.infiniteLoading = true
      }

      if (this.firstRequest) {
        params.statuses = defaultStatusValues
      }

      const newParams = params
      delete newParams.page
      delete newParams.per
      delete newParams.sort
      delete newParams.order
      if (this.selectedItems.length > 0) {
        newParams.vehicle_id = this.selectedItems.map(item => item.id)
      }

      this.exportEx = {
        show: true,
        params: newParams,
      }
    }
  },
  watch: {
    conditionChooser: {
      deep: true,
      async handler(n, o) {
        const copy = [...this.items]
        this.items = []
        this.loading = true
        this.loading = false
        this.items = copy
      }
    },
    all(n, o) {
      if (n) {
        this.selectedItems = this.items
      } else {
        this.selectedItems = []
      }
    },
    companyFilter(n, o) {
      this.multiFilter = []
      n && n.id ? this.getLocations(n.id) : ''
    },
    search(n, o) {
      this.asyncGetVehicles()
    },
    selectedItems: {
      deep: true,
      handler(n, o) {
        this.$root.$emit('clearSelectedVehicle', n)
        if (n.length > 0) {
          this.allCalculator(n)
        } else {
          this.initSummaryData()
        }
      }
    },
    defaultMarketValueUpdated: {
      deep: true,
      async handler(n, _) {
        if (n !== null) {
          this.$store.commit('profit/SET_DEFAULT_MARKET_VALUE_UPDATED', null);
          await this.fetchItem(n)
        }
      }
    },
    manuallyPriced: {
      deep: true,
      async handler(n, _) {
        this.page = 1
        this.items = []
        await this.asyncGetVehicles()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.custom-item-icon {
  z-index: 999;
  position: fixed;
  top: 60%;
}

.right-0 {
  right: 0;
}

.table-cell {
  display: table-cell;
}

.table-none {
  display: none;
}

.advanced-vehicles {
  position: relative;
  margin-top: 100px;
  width: 100%;
  max-height: calc(100vh - 265px)
}

.tag-item {
  margin-right: -5px;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50%;
}

.pd-15 {
  padding: 15px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  .card-value {
    font-weight: 700;
    font-size: 25px;
    color: #fff;
  }

  .card-title {
    font-weight: 300;
    font-size: 13px;
    color: #fff;
  }
}

.inner-side-sticky {
  padding: 10px;
  width: 210px;
  display: flex;
  transform: translateZ(0);

  position: fixed;

  .col-12 {
    margin-bottom: 10px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    .side-effect {
      border-radius: 5px;
      padding: 8px;
      display: flex;
      flex-flow: column nowrap;
      flex: 1;
      width: 100%;
      align-items: center;
      justify-content: center;

      &.clickable {
        cursor: pointer;
      }

      .card-title {
        color: #fff;
        font-size: 13px;
        font-weight: 300;
        text-align: center;
      }

      .card-value {
        color: #fff;
        text-align: center;
        font-size: 20px;
        font-weight: 700;
      }
    }
  }
}

@media only screen and (max-width: 1023px), (min-device-width: 768px) and (max-device-width: 1023px) {
  .hide-me-on-phone {
    display: none;
  }
  .q-left-static {
    left: 0;
  }
  .inner-side-sticky {
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
  }
  table {
    background: transparent;
    margin-top: 10px;
    z-index: 0;
    margin-left: 20px !important;
    width: calc(100% - 20px);
  }
  td,
  th {
    padding: 10px 0 !important;
  }
}

.mark-table {
  background: rgba(0, 0, 0, 0.12) !important;
}

.flip-list-move {
  transition: transform 500ms;
}

.hoverable-tr {
  &:hover {
    td {
      transition: 500ms all;
      background: #f7f7f7;
    }
  }
}

.table-scroll {
  position: relative;
  z-index: 1;
  overflow: auto;
  width: 100%;
  height: auto !important;
  margin-left: 235px;

  &.sorting {
    opacity: .5;
  }
}

.table-scroll table {
  width: 100%;
  min-width: 1266px;
  border-collapse: separate;
  border-spacing: 0;

  th,
  td {
    cursor: auto !important;
  }
}

.table-wrap {
  position: relative;
}

.table-scroll {
  th {
    align-items: center;
    padding: 15px 5px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
  }

  td {
    font-size: 12px;
    padding: 15px 5px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
    cursor: pointer;
  }
}

.inner-side-sticky {
  padding: 10px;
  width: 210px;
  display: flex;
  transform: translateZ(0);

  position: fixed;

  .col-12 {
    margin-bottom: 10px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    .side-effect {
      border-radius: 5px;
      padding: 8px;
      display: flex;
      flex-flow: column nowrap;
      flex: 1;
      width: 100%;
      align-items: center;
      justify-content: center;

      &.clickable {
        cursor: pointer;
      }

      .card-title {
        color: #fff;
        font-size: 13px;
        font-weight: 300;
        text-align: center;
      }

      .card-value {
        color: #fff;
        text-align: center;
        font-size: 20px;
        font-weight: 700;
      }
    }
  }
}

.graph-btn {
  position: relative;
  display: block;
  padding: 3px;
  width: 30px;
  height: 30px;
  color: #7e7e7e;
  cursor: pointer;

  &:hover {
    color: #000;
  }
}

@media only screen and (max-width: 1023px), (min-device-width: 768px) and (max-device-width: 1023px) {
  .hide-me-on-phone {
    display: none;
  }
  .q-left-static {
    left: 0;
  }
  .inner-side-sticky {
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
  }
  table {
    background: transparent;
    margin-top: 10px;
    z-index: 0;
    margin-left: 20px !important;
    width: calc(100% - 20px);
  }
  td,
  th {
    padding: 10px 0 !important;
  }
}

@media only screen and (max-width: 600px) {
  .table-scroll th,
  .table-scroll td {
    padding: 15px 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    vertical-align: center;
    text-align: center;
  }
}

@media only screen and (max-width: 1023px) {
  .table-scroll {
    position: relative;
    z-index: 1;
    overflow: auto;
    width: 100%;
    margin-left: -15px;
  }
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.container-checkbox {
  width: 18px;
  cursor: pointer;
  height: 18px;
  text-align: center;
  border: 2px solid rgba(0, 0, 0, 0.54);
}

.underlined {
  position: relative;
  display: inline-block;
  padding-bottom: 1px;
  border-bottom: 1px solid #444;
}

.top-actions {
  position: absolute;
  top: 60px;
  right: 0;
  padding: 10px 25px;
  width: 100%;
  height: 60px;

  .selection {
    margin: 8px 15px 0;
  }

  .q-btn {
    .q-icon {
      font-size: 14px;
    }
  }
}
</style>
